const xAccountName = process.env.REACT_APP_X_ACCOUNT
const xAccountUrl = `https://x.com/${xAccountName}`

export const actionData = [
  {
    actionText: 'Web Chatbot',
    description:
      'Interact with Traicy directly on the Trackgood platform. Ask questions about sustainability, find eco-friendly products, and get insights on ethical brands.',
    disabled: false,
  },
  {
    actionText: 'Autonomous X Bot',
    description:
      " Traicy's Twitter bot engages with the sustainability community autonomously. Follow Traicy on Twitter for updates, challenges, and discussions on ethical practices.",
    disabled: false,
    onClick: () => {
      window.open(xAccountUrl, '_blank')
    },
  },
  {
    actionText: 'Telegram Bot',
    description:
      "Access Traicy's ESG insights on the go through Telegram. Ask about brands’ sustainability practices, find eco-friendly recommendations, and receive instant responses.",
    disabled: false,
    onClick: undefined,
  },
  {
    actionText: 'Based Agent',
    description:
      "An AI agent with on-chain capabilities, Traicy's Based Agent verifies ESG data directly on the blockchain, ensuring transparency and authenticity for all tracked data.",
    disabled: true,
  },
]
